import { isFeatureEnabled } from '@/utils/featureFlags';

export default [
  {
    path: '/online-inquiry',
    component: () => import("../layout/PageLayoutWithoutContainer.vue"),
    meta: { featureFlag: 'VUE_APP_FEATURE_ONLINEINQUIRY' },
    beforeEnter: (to) => {
      if (!isFeatureEnabled(to.meta.featureFlag)) return false;
      return true;
    },
    children: [
      {
        path: "",
        name: 'OnlineInquiry',
        component: () => import('@/views/OnlineInquiry/OnlineInquiryView.vue')
      }
    ]
  }
];